import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import 'react';
import { getDefaultThemedOptions, themed } from '@indeed/ifl-css';
import { useStepperContext, useStep, StepProvider } from './context.js';
import transparentize from '../../utils/transparentize.js';
import transition from '../../utils/transition.js';
import { StyledCircle, StyledLabelChildren } from './StepLabel.js';
import { jsx } from '@emotion/react';
import '@indeed/ifl-icons/Check';
import '@indeed/ifl-icons/Error';
import '../Stack/Stack.js';
import '../../utils/displayName.js';
import '../IconWrapper/IconWrapper.js';

const themedOptions = getDefaultThemedOptions("active", "complete", "invalid", "nextActive", "nextComplete", "nextDisabled", "variant", "vertical");
const StyledListItem = /*#__PURE__*/themed("li", process.env.NODE_ENV === "production" ? _extends({}, {
  target: "eqy5jub0"
}, themedOptions) : _extends({}, {
  target: "eqy5jub0",
  label: "StyledListItem"
}, themedOptions))(_ref => {
  let {
    active,
    complete,
    invalid,
    nextDisabled,
    variant,
    vertical
  } = _ref;
  return {
    fontWeight: active ? "bold" : "normal",
    transition: _ref2 => {
      let {
        transitions
      } = _ref2;
      return transition(transitions.slow, "border-color", "box-shadow", "opacity");
    },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none"
    },
    textAlign: vertical ? "start" : "center",
    flex: vertical ? "0" : "1 0",
    margin: variant === "segmented" ? ".25rem" : undefined,
    paddingInlineStart: vertical && variant === "segmented" ? ".75rem" : undefined,
    paddingBlockStart: !vertical && variant === "segmented" ? ".5rem" : undefined,
    fontFamily: "default",
    fontSize: "2",
    minBlockSize: vertical ? "3rem" : "initial",
    minInlineSize: vertical ? undefined : 0,
    position: "relative",
    counterIncrement: "step",
    "&[disabled], &[aria-disabled]": {
      pointerEvents: "none",
      userSelect: "none",
      [`${StyledLabelChildren}`]: {
        opacity: 0.4
      },
      [`${StyledCircle}`]: {
        borderColor: _ref3 => {
          let {
            rawColors
          } = _ref3;
          return transparentize(0.4, rawColors.border.strong);
        },
        "&::before": {
          opacity: 0.4
        }
      },
      // Track
      "::before": {
        opacity: 0.4
      }
    },
    // Tracks
    ...(variant !== "segmented" && {
      "&:not(:last-of-type)::before": {
        content: '""',
        position: "absolute",
        insetBlockStart: vertical ? "2rem" : "0.6875rem",
        // DEFAULT_TOP (0) + CIRCLE (24) + GAP_BETWEEN_CIRCLE_AND_TRACK (8)
        insetInlineStart: vertical ? "0.6875rem" : "calc(50% + 1.25rem)",
        // DEFAULT_LEFT (50%) + CIRCLE_SIZE / 2 (12) + GAP_BETWEEN_CIRCLE_AND_TRACK (8)
        inlineSize: vertical ? "0.0625rem" : "calc(100% - 2.5rem)",
        // STEP_SIZE (100%) - CIRCLE_SIZE (24) - GAP_BETWEEN_CIRCLE_AND_TRACK * 2 (16)
        blockSize: vertical ? "calc(100% - 2.5rem)" : "0.0625rem",
        // STEP_SIZE (100%) - CIRCLE_SIZE (24) - GAP_BETWEEN_CIRCLE_AND_TRACK * 2 (16)
        backgroundColor: "border.strong",
        // Uses border token since it's perceived as a line
        transition: _ref4 => {
          let {
            transitions
          } = _ref4;
          return transition(transitions.slow, "opacity");
        },
        "@media (prefers-reduced-motion: reduce)": {
          transition: "none"
        },
        ...(nextDisabled && {
          opacity: 0.4
        })
      }
    }),
    // Segmented tracks
    ...(variant === "segmented" && {
      "::before": {
        content: '""',
        display: "block",
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        insetInlineEnd: !vertical ? 0 : undefined,
        insetBlockEnd: !vertical ? undefined : 0,
        blockSize: vertical ? undefined : !active ? ".125rem" : ".25rem",
        marginBlockStart: vertical ? undefined : !active ? 0 : "-.125rem",
        inlineSize: !vertical ? undefined : !active ? ".125rem" : ".25rem",
        borderRadius: active ? "md" : "sm",
        // Uses border tokens since it's perceived as a line
        backgroundColor: invalid ? "border.status.critical.strong" : complete ? "border.strong" : active ? "border.strong" : "border",
        transition: _ref5 => {
          let {
            transitions
          } = _ref5;
          return vertical ? transition(transitions.slow, "inline-size", "background-color", "border-radius") : transition(transitions.slow, "block-size", "background-color", "border-radius", "margin-block-start");
        },
        "@media (prefers-reduced-motion: reduce)": {
          transition: "none"
        }
      }
    })
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const InternalStep = _ref6 => {
  let {
    complete,
    invalid,
    index,
    ...props
  } = _ref6;
  const {
    activeIndex,
    stepsArray,
    variant,
    vertical
  } = useStepperContext();
  const active = activeIndex === index;
  const nextStepActive = activeIndex === index + 1;
  const nextStepComplete = stepsArray[index + 1]?.props.complete;
  const nextStepDisabled = stepsArray[index + 1]?.props.disabled;
  const stepContextValue = useStep({
    active,
    complete,
    invalid
  });
  return jsx(StepProvider, {
    value: stepContextValue
  }, jsx(StyledListItem, _extends({
    "aria-current": active ? "step" : undefined,
    active: active,
    complete: complete,
    invalid: invalid,
    nextActive: nextStepActive,
    nextComplete: nextStepComplete,
    nextDisabled: nextStepDisabled,
    variant: variant,
    vertical: vertical
  }, props)));
};
InternalStep.displayName = "Step";
const Step = InternalStep;

export { Step, StyledListItem };
